module.exports = __webpack_public_path__ + "img/marker_offers.f14e421b.svg";